export const statusValidation = {
  USER_STATUS: "active",
};
